import { useNavigate } from 'react-router-dom';
import { Button, Card } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { useGetFunctionalitiesQuery } from '@app/api/functionalitiesApi';
import { PageLoader } from '@app/components/PageLoader';
import { FINANCING_OPTIONS } from '@app/configs/financing';
import { ROUTES } from '@app/configs/routes';
const FinanceOptions = () => {
    var _a, _b;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { data: functionalities, isLoading } = useGetFunctionalitiesQuery();
    const showInvest = (_a = functionalities === null || functionalities === void 0 ? void 0 : functionalities[FINANCING_OPTIONS.investing]) === null || _a === void 0 ? void 0 : _a.enabled;
    const showBorrow = (_b = functionalities === null || functionalities === void 0 ? void 0 : functionalities[FINANCING_OPTIONS.borrowing]) === null || _b === void 0 ? void 0 : _b.enabled;
    if (isLoading) {
        return <PageLoader />;
    }
    const handleBorrowClick = () => {
        navigate(ROUTES.borrowerStart);
    };
    const handleInvestClick = () => {
        navigate(ROUTES.investorStart);
    };
    return (<>
            <h1 className="mb-6 font-bold text-2xl">{t('financing.home_page.project_name')}</h1>

            <Card className="w-full p-1.5 mb-6">
                <h3 className="mb-6 font-medium text-xl">{t('financing.home_page.welcome_to_p2p')}</h3>
                <p className="mt-2 text-base font-normal leading-normal">{t('financing.home_page.description')}</p>
            </Card>

            <Card className="w-full p-1.5 mb-6">
                <h3 className="mb-6 font-medium text-xl">{t('financing.home_page.your_profile')}</h3>
                <p className="mt-2 mb-6 text-base font-normal leading-normal">
                    {t('financing.home_page.what_activity')}
                </p>

                <div className="grid grid-cols-1 gap-2 max-w-80 md:grid-cols-2">
                    {showBorrow && (<Button type="button" variant="primary" className="w-full" onClick={handleBorrowClick} label={t('financing.home_page.borrow')}/>)}
                    {showInvest && (<Button type="button" variant="primary" className="w-full" onClick={handleInvestClick} label={t('financing.home_page.invest')}/>)}
                </div>
            </Card>
        </>);
};
export default FinanceOptions;
